
/* eslint-disable no-unused-vars */

import { Vue, Component, Prop } from 'vue-property-decorator';
import { JobAdditionalItem, GeneralInvoicingTargetEnum } from '@gid/models';
import { JobAdditionalItems } from '../../store/job-additional-items';
import { getModule } from 'vuex-module-decorators';

@Component
export default class AdditionalItem extends Vue {
  @Prop() readonly jobId!: string;
  @Prop({ type: Object }) readonly item!: JobAdditionalItem;
  @Prop({ type: Number }) readonly index!: number;
  @Prop() hidePricePurchasing!: boolean;
  @Prop() hidePriceSelling!: boolean;
  @Prop({ default: true }) hidePriceList!: boolean;
  @Prop() editable!: boolean;
  @Prop() editPriceSelling!: boolean;
  @Prop() editPricePurchasing!: boolean;
  @Prop() editPriceList!: boolean;
  @Prop() editInvoicingTarget!: boolean;
  @Prop() context!: string;
  @Prop() readonly!: boolean;

  // Computed
  get store(): JobAdditionalItems {
    return getModule(JobAdditionalItems, this.$store);
  }

  get invoicingTargets() {
    return Object.values(GeneralInvoicingTargetEnum);
  }

  get invoicingTargetAccount() {
    const t = this.$store.getters.jobInvoicingTargets(this.jobId);
    return t.general[this.item.invoicingTarget] ?? {};
  }

  get priceListStyle() {
    if (this.item.invoicingTarget === GeneralInvoicingTargetEnum.CUSTOMER) {
      return { 'background-color': '#D4EDDA' };
    }
    return null;
  }

  get priceSellingStyle() {
    if (
      this.item.invoicingTarget === GeneralInvoicingTargetEnum.BRAND ||
      this.item.invoicingTarget === GeneralInvoicingTargetEnum.BRAND_1 ||
      this.item.invoicingTarget === GeneralInvoicingTargetEnum.BRAND_2
    ) {
      return { 'background-color': '#D4EDDA' };
    }
    return null;
  }

  get invoicingTargetEntity() {
    let entity = 'Customer';
    if (this.item.invoicingTarget.startsWith('Brand')) entity = 'Brand';
    if (this.item.invoicingTarget.startsWith('GID')) entity = 'Partner';
    return entity;
  }

  measure(measure) {
    if (measure && !['Count', 'Piece', 'Euro', '0,5 h'].includes(measure)) {
      return measure;
    } else {
      return '×';
    }
  }

  deleteItem() {
    this.store.removeItem({
      jobId: this.jobId,
      byIndex: this.index,
    });
  }
}
